import React, { useEffect, useState } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import api from "../../../components/services/api";
import moment from "moment";
import { useFormik } from "formik";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import DateTimePicker from "@mui/lab/DateTimePicker";

export default function DialogAddTrain(props) {
  //   const classes = useStyles();
  const EmpId = localStorage.getItem("EmpId");
  const history = useHistory();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [BargeList, setBargeList] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [TugList, setTugList] = useState([]);
  const [trainRoute, setTrainRoute] = useState([]);
  const [Submitting, setSubmitting] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      dateFrom: "",
      dateTo: "",
      // barge: "",
      // tug: "",
      TrainRouteId: '',
      locationFrom: "",
      locationTo: "",
      h_from: "",
      h_to: "",
      h_o_from: "",
      h_o_to: "",
    },
    onSubmit: (values) => {
      const createId = EmpId;
      setSubmitting(true);
      setTimeout(() => {
        const data = {
          StartDate: !values.dateFrom
            ? moment(new Date()).format("YYYY-MM-DD HH:mm")
            : moment(values.dateFrom).format("YYYY-MM-DD HH:mm"),
            EndDate: !values.dateTo
            ? moment(new Date()).format("YYYY-MM-DD HH:mm")
            : moment(values.dateTo).format("YYYY-MM-DD HH:mm"),
          // barge: values.barge,
          // tug: values.tug,
          TrainRouteId: values.TrainRouteId,
          LocationFromId: values.locationFrom,
          LocationToId: values.locationTo,
          InboundTransitTime: values.h_from,
          InboundOperationTime: values.h_o_from,
          OutboundTransitTime: values.h_to,
          OutboundOperationTime: values.h_o_to,
        };
        api
          .post("api/train/create", data)
          .then((respose) => {
            handleClose();
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "สำเร็จ!",
                "เพิ่มตารางการเดินเรือสำเร็จ !",
                "success"
              ).then((result) => {
                if (result.isConfirmed) {
                  props.ScheduleList()
                  handleClose();
                  // getLocationList();
                  // getBargeList();
                  // getTugList();
                }
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
        // console.log(data);
        setSubmitting(false);
      }, 400);
    },
  });

  const getLocationList = async () => {
    try {
      const result = await api.get("api/master/location");
      const _result = result.data.data;
      setLocationList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  // const getBargeList = async () => {
  //   try {
  //     const result = await api.get("api/barge/list");
  //     const _result = result.data;
  //     setBargeList(_result);
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };

  // const getTugList = async () => {
  //   try {
  //     const result = await api.get("api/tug/list");
  //     const _result = result.data;
  //     setTugList(_result);
  //   } catch (error) {
  //     console.log("error => ", error);
  //   }
  // };
  const getTrainroute = async () => {
    try {
      const result = await api.get("api/trainroute/list");
      const _result = result.data;
      setTrainRoute(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const handleClose = () => {
    props.DialogAddClose(false);
    formik.setFieldValue("dateFrom", "");
    formik.setFieldValue("dateTo", "");
    formik.setFieldValue("barge", "");
    formik.setFieldValue("tug", "");
    formik.setFieldValue("locationFrom", "");
    formik.setFieldValue("locationTo", "");
    formik.setFieldValue("h_from", "");
    formik.setFieldValue("h_to", "");
    formik.setFieldValue("h_o_from", "");
    formik.setFieldValue("h_o_to", "");
  };

  useEffect(() => {
    getLocationList();
    getTrainroute()
    // getBargeList();
    // getTugList();
  }, []);

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.DialogAdd}
        onClose={() => handleClose()}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
      >
        <DialogTitle id="responsive-dialog-title">
          {
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Create Train Schedule
            </Typography>
          }
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            <h5 className="textcolordarkblue">รายละเอียดการบริการ</h5>
          </DialogContentText> */}

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  inputFormat="dd MMM yyyy HH:mm"
                  name="dateFrom"
                  value={
                    formik.values.dateFrom ? formik.values.dateFrom : new Date()
                  }
                  onChange={(newValue) => {
                    formik.setFieldValue("dateFrom", newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Date From"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  inputFormat="dd MMM yyyy HH:mm"
                  name="dateTo"
                  value={
                    formik.values.dateTo ? formik.values.dateTo : new Date()
                  }
                  onChange={(newValue) => {
                    formik.setFieldValue("dateTo", newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Date To"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="locationFrom">Route Name</InputLabel>
                <Select
                  name="TrainRouteId"
                  value={formik.values.TrainRouteId}
                  label="Route Name"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={formik.handleChange}
                >
                  {trainRoute.map((data) => (
                    <MenuItem value={data.TrainRouteId}>
                      {data.RouteName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* <FormControl fullWidth>
                <InputLabel id="barge">BARGE</InputLabel>
                <Select
                  name="barge"
                  id="barge"
                  value={formik.values.barge}
                  label="BARGE"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={(e, newValue) => {
                    if (newValue) {
                      formik.setFieldValue("barge", e.target.value);
                    } else {
                      formik.setFieldValue("barge", "");
                    }
                  }}
                >
                  {BargeList?.map((data) => (
                    <MenuItem value={data.BargeId}>{data.BargeName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="TUG">TUG</InputLabel>
                <Select
                  name="tug"
                  id="tug"
                  value={formik.values.tug}
                  label="TUG"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={(e, newValue) => {
                    if (newValue) {
                      formik.setFieldValue("tug", e.target.value);
                    } else {
                      formik.setFieldValue("tug", "");
                    }
                  }}
                >
                  {TugList?.map((data) => (
                    <MenuItem value={data.TugId}>{data.TugName}</MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="locationFrom">Location From</InputLabel>
                <Select
                  name="locationFrom"
                  id="locationFrom"
                  value={formik.values.locationFrom}
                  label="Location From"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={formik.handleChange}
                >
                  {LocationList.map((data) => (
                    <MenuItem value={data.LocationId}>
                      {data.LocationName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="locationTo">Location To</InputLabel>
                <Select
                  name="locationTo"
                  id="locationTo"
                  value={formik.values.locationTo}
                  label="Location To"
                  style={{
                    width: "100%",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                  onChange={formik.handleChange}
                >
                  {LocationList.map((data) => (
                    <MenuItem value={data.LocationId}>
                      {data.LocationName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="h_o_from"
                label="Hour Operation From"
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={formik.handleChange}
                value={formik.values.h_o_from}
                InputLabelProps={{ shrink: true }}
              // value={etaetd}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="h_o_to"
                label="Hour Operation To"
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={formik.handleChange}
                value={formik.values.h_o_to}
                InputLabelProps={{ shrink: true }}
              // value={etaetd}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                name="h_from"
                label="Transit Time From"
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={formik.handleChange}
                value={formik.values.h_from}
                InputLabelProps={{ shrink: true }}
              // value={etaetd}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="h_to"
                label="Transit Time To"
                variant="outlined"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onChange={formik.handleChange}
                value={formik.values.h_to}
                InputLabelProps={{ shrink: true }}
              // value={etaetd}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <form onSubmit={formik.handleSubmit}>
            <Button
              sx={{ width: 80 }}
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={() => handleClose()}
            >
              close
            </Button>
            <Button
              sx={{ width: 80 }}
              type="submit"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
            // disabled={Submitting}
            >
              {Submitting && <CircularProgress size={22} />}
              {!Submitting && "SAVE"}
            </Button>
          </form>
        </DialogActions>
      </Dialog>
    </div>
  );
}
